/* assets/nalli-stores.js — WS10 vanilla rewrite of theme-live/assets/stores.js (jQuery removed).
   Loaded (deferred) only on the 8 store page.template_suffix values via snippets/nalli-head.liquid.
   Behavior parity with live:
   - mobile (<=768px at load): state header click toggles .mobile_data_store on its list,
     closing every other open state
   - desktop: state header click runs a max-height accordion (.activated / .actived_main_stse),
     collapsing all other states, preserving scroll position
   - all-stores page: country tab strip filters state groups by data-attr; non-India
     countries auto-open and hide their state header; India tab auto-selected on load
   - other store pages: .inner_height_data card bodies equalized to the tallest
   - #hash deep link opens + scrolls to the matching state section (offset now handled
     by scroll-margin-top in nalli-stores.css, not a hardcoded -200px)
   - clicking a stores submenu item (.Custom_Menu_stores) reloads after 800ms
   4.1.3 note: desktop scrolls inside .page-wrapper (squeeze layout), so scroll position
   is read from the real scroll container, never window.scrollY. */

(function () {
  'use strict';

  function getScroller() {
    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight) {
      var overflowY = getComputedStyle(pageWrapper).overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') return pageWrapper;
    }
    return document.scrollingElement || document.documentElement;
  }

  function init() {
    var isMobile = window.innerWidth <= 768;

    /* State header toggles (mobile tabs / desktop accordion) */
    document.querySelectorAll('.true_Tab_data .stse_drop_dwon').forEach(function (button) {
      button.addEventListener('click', function () {
        var tab = button.closest('.true_Tab_data');
        if (!tab) return;

        if (isMobile) {
          var toggle = tab.querySelector('.toggl_data_state');
          document.querySelectorAll('.true_Tab_data .toggl_data_state').forEach(function (other) {
            if (other !== toggle) other.classList.remove('mobile_data_store');
          });
          if (toggle) toggle.classList.toggle('mobile_data_store');
          return;
        }

        /* desktop accordion */
        var container = tab.querySelector('.store-list-container');
        var toggle2 = tab.querySelector('.toggl_data_state');
        var scroller = getScroller();
        var currentScrollPos = scroller.scrollTop;

        document.querySelectorAll('.true_Tab_data .store-list-container').forEach(function (other) {
          if (other === container) return;
          other.style.maxHeight = '0';
          var otherTab = other.closest('.true_Tab_data');
          if (!otherTab) return;
          var otherButton = otherTab.querySelector('.stse_drop_dwon');
          if (otherButton) otherButton.classList.remove('activated');
          var otherToggle = otherTab.querySelector('.toggl_data_state');
          if (otherToggle) otherToggle.classList.remove('actived_main_stse');
        });

        if (container) {
          var isOpen = container.style.maxHeight !== '' && container.style.maxHeight !== '0px';
          if (isOpen) {
            container.style.maxHeight = '0';
            button.classList.remove('activated');
            if (toggle2) toggle2.classList.remove('actived_main_stse');
          } else {
            container.style.maxHeight = container.scrollHeight + 'px';
            button.classList.add('activated');
            if (toggle2) toggle2.classList.add('actived_main_stse');
          }
        }

        scroller.scrollTop = currentScrollPos;
      });
    });

    /* All-stores page: country tab strip */
    var countryTabs = document.querySelectorAll(
      '.custom-mainbody-all-stores .tab_data_all_countr .inner_all_countr_data_tab'
    );
    countryTabs.forEach(function (tabEl) {
      tabEl.addEventListener('click', function () {
        var selectedAttr = tabEl.getAttribute('data-attr');
        countryTabs.forEach(function (other) {
          other.classList.remove('tab_active_kl');
        });
        tabEl.classList.add('tab_active_kl');

        document.querySelectorAll('.main_state_data_tab.true_Tab_data').forEach(function (stateTab) {
          if (stateTab.getAttribute('data-attr') === selectedAttr) {
            stateTab.style.display = '';
            if (selectedAttr !== 'india') {
              var drop = stateTab.querySelector('.stse_drop_dwon');
              if (drop) {
                drop.click();
                drop.style.display = 'none';
              }
            }
          } else {
            stateTab.style.display = 'none';
          }
        });
      });
    });
    var indiaTab = document.querySelector(".inner_all_countr_data_tab[data-attr='india']");
    if (indiaTab) indiaTab.click();

    /* Equalize card body heights (all pages except all-stores) */
    if (!document.body.classList.contains('custom-mainbody-all-stores')) {
      var maxHeight = -1;
      var heightEls = document.querySelectorAll('.toggl_data_state .store-item .inner_height_data');
      heightEls.forEach(function (el) {
        if (el.offsetHeight > maxHeight) maxHeight = el.offsetHeight;
      });
      if (maxHeight > 0) {
        document.querySelectorAll('.inner_height_data').forEach(function (el) {
          el.style.height = maxHeight + 'px';
        });
      }
    }

    /* #hash deep link: open + scroll to the matching state section */
    var hash = window.location.hash.slice(1);
    if (hash) {
      document.querySelectorAll('.shopify-section.store_sectin_data').forEach(function (sectionEl) {
        var stateTab = sectionEl.querySelector('.main_state_data_tab');
        if (!stateTab || stateTab.id !== hash) return;
        var drop = sectionEl.querySelector('.stse_drop_dwon');
        if (drop) drop.click();
        sectionEl.classList.add('blinking');
        sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(function () {
          sectionEl.classList.remove('blinking');
        }, 400);
      });
    }

    /* Stores submenu: reload after in-page hash navigation (parity with live) */
    document
      .querySelectorAll('.menu-list__list-item.Custom_Menu_stores ul.list-unstyled.sub-child-menu')
      .forEach(function (menu) {
        menu.addEventListener('click', function () {
          setTimeout(function () {
            window.location.reload();
          }, 800);
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
